// === PROFIL JOUEUR ===
// Gère le pseudo du joueur, persisté en localStorage entre les sessions.

const PSEUDO_KEY = 'deadtide_pseudo';

export class PlayerProfile {
  /** Retourne le pseudo enregistré (trimmé), ou null si aucun */
  static getPseudo(): string | null {
    try {
      const val = localStorage.getItem(PSEUDO_KEY);
      return val && val.trim().length > 0 ? val.trim() : null;
    } catch {
      return null;
    }
  }

  /** Enregistre un pseudo (trim automatique) */
  static setPseudo(pseudo: string): void {
    try {
      localStorage.setItem(PSEUDO_KEY, pseudo.trim());
    } catch {
      // localStorage indisponible
    }
  }

  /** Retourne true si un pseudo valide est enregistré */
  static hasPseudo(): boolean {
    return PlayerProfile.getPseudo() !== null;
  }

  /** Efface le pseudo (reset / tests) */
  static clear(): void {
    try {
      localStorage.removeItem(PSEUDO_KEY);
    } catch {
      // localStorage indisponible
    }
  }
}
